import React, { useEffect } from "react";
import VirtualTourViewer from "pages/virtual-tour";
import LoginPopup from "components/login-popup";

function SharedTourViewer() {
  useEffect(() => {
    document.body.style.setProperty("overflow", "hidden", "important");
    return () => {
      document.body.style.setProperty("overflow", "auto", "important");
    };
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        overflow: "hidden",
        zIndex: 1
      }}
    >
      <VirtualTourViewer isPublic={true} />
      <LoginPopup isPublic={true} />
    </div>
  );
}

export default SharedTourViewer;
